/** Static Figma Admin Cities fixtures until admin city APIs land. */

export const CITY_KPI = [
  {
    key: "totalCities",
    title: "Total Cities",
    value: "156",
    tone: "lightblue-custom",
  },
  {
    key: "totalMembers",
    title: "Total Members",
    value: "128",
    tone: "lightteal",
  },
  {
    key: "activeProjects",
    title: "Active Projects",
    value: "10",
    tone: "purple-custom",
  },
]

export const CITY_SORT_OPTIONS = [
  { value: "city", label: "City" },
  { value: "state", label: "State" },
  { value: "country", label: "Country" },
  { value: "created_at", label: "Created At" },
  { value: "updated_at", label: "Updated At" },
  { value: "total_members", label: "Total Members" },
  { value: "active_projects", label: "Active Projects" },
]

export const DEFAULT_CITY_SORT_BY = "total_members"
export const DEFAULT_CITY_SORT_DIRECTION = "desc"

export const CITY_ROWS = [
  {
    id: "1",
    name: "New York",
    state: "New York",
    country: "United States",
    timezone: "UTC-5 (EST)",
    members: "2,847",
    status: "active",
    addedDate: "March 15, 2024",
  },
  {
    id: "2",
    name: "London",
    state: "England",
    country: "United Kingdom",
    timezone: "UTC+0 (GMT)",
    members: "1,523",
    status: "active",
    addedDate: "January 8, 2024",
  },
  {
    id: "3",
    name: "Toronto",
    state: "Ontario",
    country: "Canada",
    timezone: "UTC-5 (EST)",
    members: "987",
    status: "active",
    addedDate: "April 22, 2024",
  },
  {
    id: "4",
    name: "Dubai",
    state: "Dubai",
    country: "UAE",
    timezone: "UTC+4 (GST)",
    members: "1,204",
    status: "active",
    addedDate: "June 1, 2024",
  },
  {
    id: "5",
    name: "Sydney",
    state: "NSW",
    country: "Australia",
    timezone: "UTC+11 (AEST)",
    members: "756",
    status: "active",
    addedDate: "October 10, 2024",
  },
  {
    id: "6",
    name: "Paris",
    state: "Île-de-France",
    country: "France",
    timezone: "UTC+1 (CET)",
    members: "1,892",
    status: "active",
    addedDate: "February 20, 2024",
  },
  {
    id: "7",
    name: "Tokyo",
    state: "Tokyo",
    country: "Japan",
    timezone: "UTC+9 (JST)",
    members: "2,104",
    status: "active",
    addedDate: "May 3, 2024",
  },
  {
    id: "8",
    name: "Berlin",
    state: "Berlin",
    country: "Germany",
    timezone: "UTC+1 (CET)",
    members: "1,341",
    status: "inactive",
    addedDate: "July 17, 2024",
  },
  {
    id: "9",
    name: "Singapore",
    state: "Singapore",
    country: "Singapore",
    timezone: "UTC+8 (SGT)",
    members: "642",
    status: "active",
    addedDate: "August 4, 2024",
  },
  {
    id: "10",
    name: "Cape Town",
    state: "Western Cape",
    country: "South Africa",
    timezone: "UTC+2 (SAST)",
    members: "518",
    status: "guest",
    addedDate: "September 12, 2024",
  },
  {
    id: "11",
    name: "Mumbai",
    state: "Maharashtra",
    country: "India",
    timezone: "UTC+5:30 (IST)",
    members: "1,076",
    status: "active",
    addedDate: "November 1, 2024",
  },
  {
    id: "12",
    name: "Lisbon",
    state: "Lisbon",
    country: "Portugal",
    timezone: "UTC+0 (WET)",
    members: "423",
    status: "inactive",
    addedDate: "December 9, 2024",
  },
  {
    id: "13",
    name: "Seoul",
    state: "Seoul",
    country: "South Korea",
    timezone: "UTC+9 (KST)",
    members: "891",
    status: "active",
    addedDate: "January 21, 2025",
  },
  {
    id: "14",
    name: "Mexico City",
    state: "CDMX",
    country: "Mexico",
    timezone: "UTC-6 (CST)",
    members: "734",
    status: "guest",
    addedDate: "February 14, 2025",
  },
  {
    id: "15",
    name: "Stockholm",
    state: "Stockholm",
    country: "Sweden",
    timezone: "UTC+1 (CET)",
    members: "512",
    status: "active",
    addedDate: "March 2, 2025",
  },
]
